export default {
  state: {
    message: "",
    type: "",
    show: false,
  },
  mutations: {
    notificationResetStates(state) {
      state.message = "";
      state.type = "";
      state.show = false;
    },
    notificationShow(state, notificationShow) {
      state.show = notificationShow;
    },
    writeNotification(state, notification) {
      state.message = notification.message;
      state.type = notification.type;
      state.show = true;
    },
  },
  actions: {
    createNotification(context, { message, type }) {
      context.commit("writeNotification", { message: message, type: type });
    },
  },
};
